import types from "../types";

const initial = {
  data: [],
  totalPages: 0,
};

export const adcard_reducer = (state = initial, { type, payload }) => {
  switch (type) {
    case types.ADCARD:
      const uniqueData = Array.isArray(payload.data)
        ? payload.data.filter(
            (product, index, self) =>
              index === self.findIndex((p) => p._id === product._id)
          )
        : [];
      return {
        ...state,
        data: uniqueData,
        totalPages: payload.totalPages || 0,
      };
    case types.ADCARD_RESET:
      return initial;
    case types.AUTH_RESET:
      return initial;
    default:
      return state;
  }
};
